// removed by extract-text-webpack-plugin
module.exports = {"top-logo":"top-logo__UhJfu","mt16":"mt16__zxJgf","retry":"retry__2l5Ya"};


//////////////////
// WEBPACK FOOTER
// ./routes/OrderCancelled/OrderCancelled.css
// module id = w69u
// module chunks = 16